import { useMutation, useQueryClient } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";

export interface ISyncEbayListingResponse {
  title: string;
  description: string;
  aspects: Record<string, string[]>;
  buyItNowPrice?: number;
  auctionStartPrice?: number;
  auctionReservePrice?: number;
  categoryId?: string;
  secondaryCategoryId?: string;
  fulfillmentPolicyId?: string;
  paymentPolicyId?: string;
  returnPolicyId?: string;
  condition?: string;
  conditionDescription?: string;
  enableBestOffer?: boolean;
  autoAcceptPrice?: number;
  locationKey?: string;
  storeCategoryId?: string;
  apiSource?: string;
}

export interface ISyncEbayListingWithPartId {
  partId: string;
  syncData: ISyncEbayListingResponse | null;
}

export default function useEbaySyncMutations() {
  const { post } = useApiHelper();
  const queryClient = useQueryClient();

  const syncEbayListings = useMutation(
    (partIds: string[]) => post<{ partIds: string[] }, DefaultResponseWithData<ISyncEbayListingWithPartId[]>>(`/part/sync-ebay-listings`, { partIds })
  );

  const applySyncEbayListing = useMutation(
    (data: { partId: string; syncData: ISyncEbayListingResponse }) => 
      post(`/part/${data.partId}/apply-sync-ebay-listing`, data.syncData),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["pagedTable"]);
        queryClient.invalidateQueries(["part"]);
      },
    }
  );

  const applySyncAllEbayListings = useMutation(
    (partIds: string[]) => post(`/part/apply-sync-ebay-listings`, { partIds }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["pagedTable"]);
        queryClient.invalidateQueries(["part"]);
      },
    }
  );

  return {
    syncEbayListings,
    applySyncEbayListing,
    applySyncAllEbayListings,
  };
}

